export const isPersonalSpace = (spaceKey: string | undefined): boolean => {
	return spaceKey?.[0] === '~';
};
